<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <div class="p-3">
                        <h4>Filter By</h4>
                        <div class="input-group pb-4">
                            <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery" @input="onSearchQueryInput">
                            <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <label>Order Type</label>
                                <bootstrap-select  :selectOptions="orderTypes" :selectedOption="filter.orderTypeId" :elementId="'orderTypeFilterSelect'"
                                                   :returnSelectedOptionText="true"
                                                   @changeSelect="onOrderTypeFilterSelect"></bootstrap-select>
                            </div>
                            <div class="col-6">
                                <label>Special Pricing Methods</label>
                                <bootstrap-select  :selectOptions="specialPricingMethods" :selectedOption="filter.specialPricingMethodId" :elementId="'specialPricingMethodsFilterSelect'"
                                                   :returnSelectedOptionText="true"
                                                   @changeSelect="onSpecialPricingMethodFilterSelect"></bootstrap-select>
                            </div>
                        </div>
                        <br>
                        <div class="row" v-if="showDeliveryPricing || showExTankPricing">
                            <div class="col-6">
                                <label>Zones</label>
                                <bootstrap-select  :selectOptions="zones" :selectedOption="filter.zoneId" :elementId="'zoneFilterSelect'"
                                                   :returnSelectedOptionText="true"
                                                   @changeSelect="onZoneFilterSelect"></bootstrap-select>
                            </div>
                            <div class="col-6 float-right">
                                <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                               :componentId="'productFilterRadioButtons'"
                                                               @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                            </div>
                        </div>
                        <br>
                        <active-inactive-radio-buttons v-if="!showDeliveryPricing && !showExTankPricing" :activeInactiveKey="filter.activeOrInactiveItems"
                                                       :componentId="'productFilterRadioButtons'"
                                                       @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                    </div>
                    <div class="row mt-3">
                        <div class="col-6">
                            <div class="w-100" v-if="showDeliveryPricing && canAddOrEditPricing">
                                <router-link
                                        class="btn btn-primary"
                                        :to="'/pricing/delivery/addCustomerGroupPricingForZone/' + companyId" >
                                    Add Pricing
                                </router-link>
                            </div>
                            <div class="w-100" v-if="showExTankPricing && canAddOrEditPricing">
                                <router-link
                                        class="btn btn-primary"
                                        :to="'/pricing/extank/addCustomerGroupPricingForZone/' + companyId" >
                                    Add Pricing
                                </router-link>
                            </div>
                            <div class="w-100" v-if="showDiscountGroups && canAddOrEditPricing">
                                <button class="btn btn-primary" @click="onLinkAndUnlinkDiscountGroupClick">Link Or Unlink Customer To Discount Group</button>
                            </div>
                            <div class="w-100" v-if="showDepotDiscountGroups && canAddOrEditPricing">
                                <button class="btn btn-primary" @click="onLinkAndUnlinkDepotDiscountGroupClick">Link or Unlink Customer To Depot Discount Group</button>
                            </div>
                        </div>
                        <div class="col-6">
                            <button class="btn btn-primary float-right" @click="onFilterSearchClicked">Search</button>
                        </div>
                    </div>

                    <customer-group-pricing-for-zone-component
                            v-if="showDeliveryPricing"
                            :companyId="companyId"
                            :companyName="customer.registeredCompanyName"
                            :activeOrInactiveKey="filter.activeOrInactiveItems"
                            :searchQuery="filter.customerSearchQuery"
                            :filterStateChanged="filterStateChanged"
                            :zoneId="filter.zoneId"
                            :showTableActions="canAddOrEditPricing"></customer-group-pricing-for-zone-component>

                    <customer-discount-groups-management-component
                            v-if="showDiscountGroups"
                            :companyId="companyId"
                            :companyName="customer.registeredCompanyName"
                            :activeOrInactiveKey="filter.activeOrInactiveItems"
                            :searchQuery="filter.customerSearchQuery"
                            :filterStateChanged="filterStateChanged"
                            :showLinkingModal="showLinkingModalForDiscountGroups"
                            @linkingModalClose="onDiscountGroupLinkingModalClose"
                            :showTableActions="canAddOrEditPricing"></customer-discount-groups-management-component>

                    <customer-depot-discount-groups-management-component
                            v-if="showDepotDiscountGroups"
                            :companyId="companyId"
                            :companyName="customer.registeredCompanyName"
                            :activeOrInactiveKey="filter.activeOrInactiveItems"
                            :searchQuery="filter.customerSearchQuery"
                            :filterStateChanged="filterStateChanged"
                            :showLinkingModal="showLinkingModalForDepotDiscountGroups"
                            @linkingModalClose="onDepotDiscountGroupLinkingModalClose"
                            :showTableActions="canAddOrEditPricing"></customer-depot-discount-groups-management-component>
                    
                    <customer-group-pricing-for-zone-ex-tank
                            v-if="showExTankPricing"
                            :companyId="companyId"
                            :companyName="customer.registeredCompanyName"
                            :activeOrInactiveKey="filter.activeOrInactiveItems"
                            :searchQuery="filter.customerSearchQuery"
                            :filterStateChanged="filterStateChanged"
                            :zoneId="filter.zoneId"
                            :showTableActions="canAddOrEditPricing"></customer-group-pricing-for-zone-ex-tank>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>
</div>
